// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"f1c4460f","632":"b2246c41","699":"e7b831c5","924":"f594fc48"}[chunkId] + ".chunk.js";
};